import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { CloseDialog } from '../../shared/dialog-close/dialog-close';
import { FormGroup, FormControl, Validators } from '../../../../node_modules/@angular/forms';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { NewBusiness } from '../../business/models/new-business-model';
import { BusinessTag } from '../../business/models/business-tag.model';
var AddBusinessDialogComponent = /** @class */ (function () {
    function AddBusinessDialogComponent(_dialogRef, data, _businessManagerService) {
        this._dialogRef = _dialogRef;
        this.data = data;
        this._businessManagerService = _businessManagerService;
        this.isLoading = false;
        this.airport = data.airport;
        this.facilityType = data.facilityType;
    }
    AddBusinessDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = new FormGroup({
            name: new FormControl('', [Validators.required])
        });
        this._dialogRef.backdropClick().subscribe(function () {
            var CLOSE_DIALOG = new CloseDialog();
            CLOSE_DIALOG.cancelButtonClicked = true;
            _this._dialogRef.close(CLOSE_DIALOG);
        });
    };
    AddBusinessDialogComponent.prototype.onSubmit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var CLOSE_DIALOG, newBusiness, BUSINESS, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.businessTags = [];
                        if (this.facilityType === 'FLYING CLUB') {
                            this.businessTags.push(Object.assign(new BusinessTag(), { tagName: 'Flying Club' }));
                            this.businessTags.push(Object.assign(new BusinessTag(), { tagName: 'Flying Club::Non-Equity Club' }));
                        }
                        CLOSE_DIALOG = new CloseDialog();
                        BUSINESS = Object.assign(new NewBusiness(), {
                            name: this.formGroup.controls['name'].value,
                            facilityType: this.facilityType,
                            airport: this.airport,
                            businessTags: this.businessTags,
                            userAdded: false
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._businessManagerService.createBusiness(BUSINESS)];
                    case 2:
                        newBusiness = _a.sent();
                        this.isLoading = false;
                        CLOSE_DIALOG.payload = newBusiness.id;
                        CLOSE_DIALOG.success = true;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        CLOSE_DIALOG.success = false;
                        if (e_1) {
                            CLOSE_DIALOG.error = e_1;
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        this._dialogRef.close(CLOSE_DIALOG);
                        return [2 /*return*/];
                }
            });
        });
    };
    return AddBusinessDialogComponent;
}());
export { AddBusinessDialogComponent };
